import * as React from 'react';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { BottomSheet as SpringBottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import '../../Styles/bottomSheet.css';
import { useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../Hooks/back/useBackStack';

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.applyStyles('dark', {
    backgroundColor: grey[800],
  }),
}));

function BottomSheet({
  children,
  headerTextSx,
  headerText = '필터',
  isHeaderChildren = false,
  headerChildren = null,
  snapPoints,
  defaultSnap,
  initialFocusRef,
  onDismiss: onDismissProp,
}) {
  const dispatch = useDispatch();
  const sheetRef = React.useRef(null);
  /** onDismiss 참조가 바뀌어도 closeSheet 정체성 유지 — [closeSheet] cleanup이 불필요하게 호출되지 않도록 */
  const onDismissPropRef = React.useRef(onDismissProp);
  onDismissPropRef.current = onDismissProp;

  const closeSheet = React.useCallback(() => {
    dispatch(BottomSheetActions.CloseBottomSheet());
    onDismissPropRef.current?.();
  }, [dispatch]);

  // 바텀시트가 마운트된 동안 BackStack에 guard 등록
  // 뒤로가기 시 시트를 닫고, 언마운트 시 자동으로 스택에서 제거
  useBackStack({
    type: 'sheet',
    onBack: closeSheet,
  });

  // 언마운트 시에만 Redux·부모 정리 (closeSheet 의존 시 매 렌더마다 cleanup → 시트가 닫히는 버그 방지)
  React.useEffect(() => {
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
      onDismissPropRef.current?.();
    };
  }, [dispatch]);

  return (
    <SpringBottomSheet
      ref={sheetRef} // ref: 바텀시트 API를 호출할 때 사용
      open={true}
      onDismiss={closeSheet}
      snapPoints={
        // snapPoints: 바텀시트가 올라오는 최소/최대 높이
        snapPoints ??
        (({ minHeight, maxHeight }) => [minHeight, maxHeight * 0.9])
      }
      defaultSnap={
        // defaultSnap: 바텀시트가 열릴 때 위치할 기본 높이
        defaultSnap ?? (({ maxHeight }) => maxHeight * 0)
      }
      initialFocusRef={initialFocusRef ?? false} // initialFocusRef: 바텀시트 OPEN 시 포커스를 어느 요소로 둘지 결정
    >
      <StyledBox>
        <Box
          sx={{
            px: 2,
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {isHeaderChildren ? (
            headerChildren
          ) : (
            <Typography
              sx={{
                py: 2,
                pr: 1,
                color: '#3A3A3A',
                fontSize: '18px',
                ...headerTextSx,
              }}
            >
              {headerText}
            </Typography>
          )}
        </Box>
      </StyledBox>
      <StyledBox sx={{ px: '8px' }}>
        {children}
      </StyledBox>
    </SpringBottomSheet>
  );
}

export default BottomSheet;
